import React from 'react'

interface HoverManagerProps {
  readonly children: (isHovered: boolean) => React.ReactNode
}

interface HoverManagerState {
  readonly isHovered: boolean
}

export class HoverManager extends React.Component<
  HoverManagerProps,
  HoverManagerState
> {
  constructor(props) {
    super(props)
    this.state = {
      isHovered: false
    }
  }

  public render() {
    const { children } = this.props
    const { isHovered } = this.state

    return (
      <div
        onMouseEnter={() => this.updateIsHovered(true)}
        onMouseLeave={() => this.updateIsHovered(false)}
      >
        {children(isHovered)}
      </div>
    )
  }

  private updateIsHovered = (isHovered) => {
    this.setState({
      isHovered
    })
  }
}
